export default __webpack_public_path__ + "static/media/Esha_Goel.e9cca525.jpg";